<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const { accountScopedRoute } = useAccount();

const tabs = [
  {
    routeName: 'labels_list',
    label: 'LABEL_MGMT.TABS.CONVERSATION_LABELS',
  },
  {
    routeName: 'event_labels_list',
    label: 'LABEL_MGMT.TABS.EVENT_LABELS',
  },
];

const tabsForTabBar = computed(() =>
  tabs.map(tab => ({ label: t(tab.label), key: tab.routeName }))
);

const activeTabIndex = computed(() =>
  Math.max(
    tabs.findIndex(tab => tab.routeName === route.name),
    0
  )
);

const onTabChange = tab => {
  if (tab.key === route.name) return;
  router.push(accountScopedRoute(tab.key));
};
</script>

<template>
  <div class="mb-6">
    <TabBar
      :tabs="tabsForTabBar"
      :initial-active-tab="activeTabIndex"
      @tab-changed="onTabChange"
    />
  </div>
</template>
